import React from "react";
import { Virtuoso, type VirtuosoProps } from "react-virtuoso";

type RpVirtualListProps<T> = Omit<
  VirtuosoProps<T, unknown>,
  "totalCount" | "itemContent"
> & {
  items?: T[];
  renderItem: (_item: T | undefined, _index: number) => React.ReactNode;
};

const RpVirtualList = <T,>({
  items = [],
  renderItem,
  useWindowScroll = true,
  ...rest
}: RpVirtualListProps<T>) => {
  return (
    <Virtuoso
      useWindowScroll={useWindowScroll}
      totalCount={items?.length || 0} // Total number of items to render
      itemContent={(index) => (
        <div id={`item-${index}`} className="custom-list-item">
          {renderItem(items?.[index], index)}{" "}
          {/* Dynamically render each item */}
        </div>
      )}
      {...rest}
    />
  );
};

export default RpVirtualList;
